const formatCpf = (stringCpf = "") => {
  var regex = /[.-\s]/g
  var result = stringCpf.replace(regex, "")

  return result
}

export default formatCpf
